import React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { Clouds, Goodthings, AnimGoodthings } from "../svg";
import logo from "../images/goodthings22_logo.png";

/* Page Banner
============================================================================= */

const PageBanner = ({ animated = false }) => {
	// Config

	// Render
	return (
		<div className="relative z-50 w-full pt-8 mt-8 h-88 md:mt-12">
			<div className="container relative z-50 flex flex-col items-center justify-start px-8 py-6 mx-auto md:py-10 lg:px-32 md:px-24">
				<Link to="/">
					<div style={{ width: "85vw", maxWidth: "850px" }}>
						{/* {animated ? <AnimGoodthings /> : <Goodthings />} */}
						<img src={logo} className="w-full" />
					</div>
				</Link>
			</div>
		</div>
	);
};

/* Export
============================================================================= */

export default PageBanner;
